const routes = [


	//---- Logged in "Home" page (start/landing/dashboard)
	{
		path: '/home', 
		name: "home", 
		component: () => import("./home/index.vue"),
		meta: { layout: "primary", layoutType: "default", layoutContainer: "none", isPublic: false, pageTitle: "Home", kbFile: "home", kbTitle: "" } 
	},
	{ 
		path: '/home/LotusOnly', 
		name: "home-lotus-only-view", 
		component: () => import("./home/index.vue"),
		meta: { layout: "primary", layoutType: "default", layoutContainer: "none", isPublic: false, pageTitle: "Lotus Only > Home", kbFile: "home", kbTitle: "" } 
	},






	//---- Support
	{ 
		path: '/support', 
		name: "support",
		component: () => import("./support/index.vue"),
		meta: { layout: "primary", pageTitle: "Request Support", kbFile: "support", kbTitle: "Support" } 
	},

	

	//---- "KB"
	{ 
		path: '/kb', 
		name: "kb", 
		component: () => import("./kb/index.vue"),
		meta: { layout: "primary", pageTitle: "Knowledgebase" } 
	},
	{ 
		path: '/kb/with-path',
		name: "kb-with-path", 
		component: () => import("./kb/index.vue"),
		meta: { layout: "knowledgebase", pageTitle: "Knowledgebase" } 
	},
	{ 
		path: '/kb/route/:routeName', 
		name: "kb-with-route-name", 
		component: () => import("./kb/index.vue"),
		meta: { layout: "primary", pageTitle: "Knowledgebase" } 
	},
	{ 
		path: '/kb/glossary/:term', 
		name: "kb-glossary", 
		component: () => import("./kb/index.vue"),
		meta: { layout: "primary", pageTitle: "Knowledgebase > Glossary" } 
	},



	//---- "Background Tasks"
	{ 
		path: '/background-tasks',
		name: "background-tasks", 
		component: () => import("./shared/background-tasks.vue"),
		meta: { layout: "primary", pageTitle: "Background Tasks" }
	},





	//---- "Reports" pages
	{ 
		path: '/reports/', 
		name: "reports-home",
		component: () => import("./reports/index.vue"),
		meta: { layout: "primary", pageTitle: "Reports > Show Reports" }
	},
	{ 
		path: '/reports/report/:id', 
		name: "report-by-id",
		component: () => import("./reports/report.vue"),
		meta: { layout: "primary", pageTitle: "Reports > Show Reports" }
	},
	{ 
		path: '/reports/structured-report/:id', 
		name: "structured-report-by-id",
		component: () => import("./reports/structured-report.vue"),
		meta: { layout: "primary", pageTitle: "Structured Report" }
	},
	{ 
		path: '/reports/database/:id', 
		name: "database-report-by-id",
		component: () => import("./reports/database.vue"),
		meta: { layout: "primary", pageTitle: "System Admin > Reports > Database Reports" }
	},


		//---- Timesheet module: "Buckets Report" pages
		{ 
			//path: '/buckets', 
			path: '/module/timesheets/buckets-report', 
			name: "timesheet-buckets-report-entry",
			component: () => import("./module.timesheets/buckets/index.vue"),
			meta: { layout: "primary", pageTitle: "Buckets Report", kbFile: "buckets", kbTitle: "Buckets" } 
		},
		{ 	// For system admin, and later when a user can operate across accounts
			//path: '/buckets/:accountId', 
			path: '/module/timesheets/buckets-report/:accountId', 
			name: "timesheet-buckets-report-account",
			component: () => import("./module.timesheets/buckets/index.vue"),
			meta: { layout: "primary", pageTitle: "Buckets Report", kbFile: "buckets", kbTitle: "Buckets" } 
		},

		{ 
			//path: '/buckets/bucket/:bucketId/summary', 
			path: '/module/timesheets/buckets-report/bucket/:bucketId/summary', 
			name: "timesheet-buckets-report-bucket-summary",
			component: () => import("./module.timesheets/buckets/bucket-summary.vue"),
			meta: { layout: "primary", pageTitle: "Buckets Report > Bucket Summary", kbFile: "buckets", kbTitle: "Buckets" } 
		},
		{ 
			//path: '/buckets/bucket/:bucketId/detail', 
			path: '/module/timesheets/buckets-report/bucket/:bucketId/detail', 
			name: "timesheet-buckets-report-bucket-detail",
			component: () => import("./module.timesheets/buckets/bucket-detail.vue"),
			meta: { layout: "primary", layoutType: "manage", pageTitle: "Buckets Report > Bucket Detail", kbFile: "buckets", kbTitle: "Buckets" } 
		},

		{ 
			//path: '/buckets/bucket/:bucketId/breakdown', 
			path: '/module/timesheets/buckets-report/bucket/:bucketId/breakdown', 
			name: "timesheet-buckets-report-bucket-breakdown",
			component: () => import("./module.timesheets/buckets/bucket-breakdown.vue"),
			meta: { layout: "primary", pageTitle: "Buckets Report > Bucket Breakdown", kbFile: "buckets", kbTitle: "Buckets" } 
		},







]


export default routes;